import { getRailsClient } from "../client";
import { Assignment } from "./types";

export interface Assignments {
  assignments: Assignment[];
}

export const fetchUserAssignments = async (): Promise<Assignment[]> => {
  const client = getRailsClient();
  const API = "/api/internal_api/v1/assignments";

  const { assignments } = await client.get<Assignments>(API).then(response => response.data);
  return assignments;
};
